import React, { useState } from "react"
import * as Validator from "../../utils/validator"
import * as Constants from '../../utils/constants'
import {
  Container,
  FormGroup,
  Input,
  Row,
  Col,
  Button
} from 'design-react-kit';

export const SibaCalcolaInputForm = ({ _cf, _targa, _authMode, _handleCfChange, _handleTargaChange, _handleNext }) => {

  const [cf, setCodiceFiscale] = useState(_cf);
  const [targa, setTarga] = useState(_targa);
  const [authMode, setAuthMode] = useState(_authMode);

  const onCfChanged = (event) => {
    setCodiceFiscale(event.target.value.toUpperCase())
    _handleCfChange(Validator.getValidCfOrEmptyValue(event.target.value))
  }

  const onTargaChanged = (event) => {
    setTarga(event.target.value.toUpperCase())
    //STALIGK-904: convertita targa in upperCase anche nella fun. di controllo per problema Firefox e Regexp
    _handleTargaChange(Validator.getValidTargaOrEmptyValue(event.target.value.toUpperCase()));
  }

  const onSubmit = () => {
    _handleNext();
  }

  const isCfUndefined = () => {
    return ((cf !== undefined) && (cf !== 'undefined'));
  }

  return (
    <Container className="px-2 my-2" id="calcola" tag="section" >
      <Container className="my-4" id="calcolaEpaga" tag="section" >
        <Row>
          <Col>
            <FormGroup className="my-2" >
              <Input
                id="inserisciCodiceFiscale"
                infoText="Dati proprietario"
                label="*Codice Fiscale"
                placeholder=""
                value={isCfUndefined() ? cf : ''}
                type="text"
                onChange={onCfChanged}
                required
                valid={Validator.isValidCfOrPiva(cf)}
                invalid={!Validator.isValidCfOrPiva(cf)}
                disabled={cf !== undefined && authMode === Constants.AUTH_MODE_PROTECTED}
              />
              <Input
                id="inserisciTarga"
                infoText="Targa del veicolo o numero telaio per ciclomotori/quadricicli"
                label="*Targa"
                placeholder=""
                value={targa}
                type="text"
                onChange={onTargaChanged}
                required
                valid={Validator.isValidTargaOrTelaio(targa)}
                invalid={!Validator.isValidTargaOrTelaio(targa)}
              />
            </FormGroup>
          </Col>
        </Row>
      </Container>
      <Button id="conferma_cf_targa" className="btn btn-primary" color="primary" size="sm" tag="button" onClick={onSubmit} disabled={!Validator.isValidCfOrPiva(cf) || !Validator.isValidTargaOrTelaio(targa)}>
        Conferma
      </Button>
    </Container>
  )
}

export default SibaCalcolaInputForm